import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { dataCleanseService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";


const useDataCleanseRefreshMutation = ({
	paidYear,
	paidMonth,
	onSuccessHandler,
}: {
	paidYear: string;
	paidMonth: string;
	onSuccessHandler?: Function;
}) => {
	const dispatch = useDispatch();

	return useMutation(
		({ acceptMerchantChanges }: { acceptMerchantChanges?: boolean }) => {
			dispatch(uiActions.showSpinnerOverlay());

			return dataCleanseService.refreshLists({
				paidMonth,
				paidYear,
				acceptMerchantChanges,
			});
		},
		{
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
			onSuccess() {
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useDataCleanseRefreshMutation;
